export const AVAILABLE_COMMUNICATION_BOARD_SECTIONS = [
  'supplier_status',
  'additional_sales_status',
  'important_info',
]

export const SALES_SCRIPT_SECTIONS = {
  ENERGY: 'sales_script_energy',
  TELECOM: 'sales_script_telecom',
}
